import styled, { css } from 'styled-components';

import { mixin } from '@wconcept/wconcept-ui-renewal/styles/index';

import {
  IconRadio01,
  IconRadio02Checked,
  IconCheckbox01,
} from '@wconcept/wconcept-ui-renewal/components/atoms/svg';

interface IProps {
  className: string;
}

export const Box = styled.label<IProps>`
  position: relative;
  transition: opacity 0.3s;
  ${mixin.flex({
    display: 'inline-flex',
    justify: 'flex-start',
    align: 'center',
  })}

  input[type='radio']:disabled + .label,
  input[type='radio']:disabled + .chk-inner {
    opacity: 0.5;
  }

  input[type='radio']:checked + .chk-inner {
    rect:first-child {
      fill: #000;
      stroke: none;
    }
    rect:last-child {
      fill: #fff;
    }
  }

  input[type='radio'] + .chk-inner3 circle:last-child {
    fill: #fff;
  }

  input[type='radio']:checked + .chk-inner3 circle:last-child {
    fill: #000;
  }
`;

export const Input = styled.input`
  ${mixin.a11y()}
`;

const getChkInnerStyle = () => css`
  flex: none;
  display: inline-block;
  width: 20px;
  height: 20px;

  * {
    transition: all 0.1s;
  }

  @media ${({ theme }) => theme.media.smMax} {
    width: ${mixin.pxToVw('20')};
    height: ${mixin.pxToVw('20')};
  }

  @media ${({ theme }) => theme.media.pc} {
    width: 22px;
    height: 22px;

    svg {
      width: 22px;
      height: 22px;
    }
  }
`;

export const ChkInner = styled(IconRadio01)`
  ${getChkInnerStyle()}
`;

export const ChkInner2 = styled(IconCheckbox01)`
  ${getChkInnerStyle()}
`;

export const ChkInner3 = styled(IconRadio02Checked)`
  ${getChkInnerStyle()}
`;

export const Label = styled.span`
  display: inline-block;
  font-size: 15px;
  line-height: 130%;
  margin: 0 8px;
  color: #000;

  @media ${({ theme }) => theme.media.smMax} {
    font-size: ${mixin.pxToVw('15')};
    margin: ${mixin.pxToVw('0 8')};
  }

  @media ${({ theme }) => theme.media.pc} {
    font-size: 16px;
  }
`;
